import { useCallback, useState } from 'react';

export const useDisclosure = (defaultOpen = false) => {
	const [open, setOpen] = useState(defaultOpen);

	// Stable references: consumers pass these straight into memoized menu items and modals,
	// and a fresh function on every render would invalidate their useMemo/useCallback chains.
	const onOpen = useCallback(() => setOpen(true), []);
	const onClose = useCallback(() => setOpen(false), []);
	const onToggle = useCallback(() => setOpen((prev) => !prev), []);

	return { open, onOpen, onClose, onToggle };
};
